var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9998 8.4L2.0998 13.3C1.91647 13.4833 1.68314 13.575 1.3998 13.575C1.11647 13.575 0.883138 13.4833 0.699804 13.3C0.516471 13.1167 0.424805 12.8833 0.424805 12.6C0.424805 12.3167 0.516471 12.0833 0.699804 11.9L5.5998 7L0.699804 2.1C0.516471 1.91667 0.424805 1.68333 0.424805 1.4C0.424805 1.11667 0.516471 0.883333 0.699804 0.7C0.883138 0.516666 1.11647 0.425 1.3998 0.425C1.68314 0.425 1.91647 0.516666 2.0998 0.7L6.9998 5.6L11.8998 0.7C12.0831 0.516666 12.3165 0.425 12.5998 0.425C12.8831 0.425 13.1165 0.516666 13.2998 0.7C13.4831 0.883333 13.5748 1.11667 13.5748 1.4C13.5748 1.68333 13.4831 1.91667 13.2998 2.1L8.3998 7L13.2998 11.9C13.4831 12.0833 13.5748 12.3167 13.5748 12.6C13.5748 12.8833 13.4831 13.1167 13.2998 13.3C13.1165 13.4833 12.8831 13.575 12.5998 13.575C12.3165 13.575 12.0831 13.4833 11.8998 13.3L6.9998 8.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.81752f81be1e0f245c39265e88aebc18.svg";
export { ForwardRef as ReactComponent };